export default (answers) => {
    const intAnswers = answers.map((answer) => parseInt(answer))
    const noNaAnswers = intAnswers.filter((num) => num > 0)
    const points = (noNaAnswers.length > 0) ? noNaAnswers.reduce((acc, cur) => acc + cur) : []
    return (points / (noNaAnswers.length * 3)) * 100
}


// WEBPACK FOOTER //
// ./src/selectors/subSectionScore.js